<template>
    <section class="flex print:flex-col-reverse">
        <div class="w-[calc(100%_-_var(--app-detail-aside-width))]">
            <div
                class="sticky top-[var(--app-header-height)] z-30 flex items-center gap-2 overflow-hidden h-[calc(3rem+1px)] px-4 bg-gray-tier-2 border-b border-keyline-primary print:hidden"
            >
                <div class="relative">
                    <div
                        key="j"
                        class="type-secondary flex gap-2 h-full items-center whitespace-nowrap"
                    >
                        <Link
                            class="hover:underline"
                            :href="
                                route(
                                    'web.catalog.manufacturers.show',
                                    product?.vendor?.slug
                                )
                            "
                        >
                            {{ product.vendor.display_name }}
                        </Link>
                        <span>/</span>
                        <Link
                            v-if="product?.series"
                            class="hover:underline"
                            :href="
                                route('web.catalog.products.index', {
                                    filters: {
                                        0: {
                                            field: 'filter_category',
                                            values: [
                                                product.tags?.[
                                                    'item-category'
                                                ]?.[0]?.name,
                                            ],
                                            type: 'any',
                                        },
                                        1: {
                                            field: 'filter_manufacturer',
                                            values: [
                                                product.vendor.display_name,
                                            ],
                                            type: 'any',
                                        },
                                        2: {
                                            field: 'filter_series',
                                            values: [product.series.name],
                                            type: 'any',
                                        },
                                    },
                                })
                            "
                        >
                            {{ product.series.name }}
                        </Link>
                        <span v-if="product?.series">/</span>
                        <span class="type-primary">{{ product.sku }}</span>
                    </div>
                </div>
            </div>
            <figure id="Product" data-section="0" class="sentinel">
                <ProductImageCarousel :product="product" :user="user" />
            </figure>

            <div ref="navbarSentinel" class="h-px w-full"></div>

            <AppNavbar
                v-model="isCurrent"
                :hide-back-button="true"
                :sections="sections"
                :class="{ 'shadow-lg': isSticky }"
                ref="navbar"
                class="sticky top-[91px] z-20 print:hidden"
                @update:model-value="updateSection"
            />

            <main>
                <!-- Inventory -->
                <article
                    v-show="isCurrent === 'Inventory' && useUser().isEmployee()"
                    class="relative sentinel"
                >
                    <div v-if="isLoadingMeta" class="block text-center py-24">
                        <LoadingSpinner :large="true" />
                    </div>

                    <div v-else-if="inventory && availability">
                        <!--<div class="inventory-availability flex items-center gap-2 mb-6">
              <span class="type-primary font-semibold">
                {{ useHelpers().showMeTheMoney(product.pricing_warehouse_item.list_price) }}
                <span class="type-tertiary uppercase text-2xs">{{ $t('list') }}</span>
              </span>
              <span class="type-primary font-semibold">
                {{ availability?.total }}<span v-if="Number(card.is_inventory_plus) && !is_part" class="font-normal">+</span>
                <span class="ml-1 type-tertiary uppercase text-2xs">{{ $t('in stock') }}</span>
              </span>
              <ul class="flex gap-2 pl-4">
                <li v-for="warehouse in config.warehouses" v-show="availability?.warehouses?.[warehouse?.code]?.available > 0">
                  {{ warehouse?.state }}:
                  <span>{{ availability?.warehouses?.[warehouse?.code].available }}</span>
                </li>
              </ul>
              <span class="dark:bg-white text-white dark:text-black text-sm w-6 h-6 flex items-center justify-center rounded-full">{{
                product.status
              }}</span>
            </div>-->
                        <div class="mb-24">
                            <div class="py-8 px-6 grid grid-cols-5 gap-4">
                                <div class="bg-gray-tier-5 rounded-lg p-8">
                                    <dt class="text-gray-475 text-sm truncate whitespace-nowrap" title="Total Available">Total Available</dt>
                                    <dd class="font-medium text-2xl" :class="{ 'text-orange': availability?.total < 0 }">
                                        {{ availability?.total }}
                                    </dd>
                                </div>
                                <div class="bg-gray-tier-5 rounded-lg p-8">
                                    <dt class="text-gray-475 text-sm truncate whitespace-nowrap" title="Physical On Hand">Physical On Hand</dt>
                                    <dd class="font-medium text-2xl" :class="{ 'text-orange': availability?.total_on_hand - availability?.total_committed < 0 }">
                                        {{ availability?.total_on_hand - availability?.total_committed }}
                                    </dd>
                                </div>
                                <div class="bg-gray-tier-5 rounded-lg p-8">
                                    <dt class="text-gray-475 text-sm truncate whitespace-nowrap" title="Available to Build">Available to Build</dt>
                                    <dd class="font-medium text-2xl">
                                        {{ Math.max(0, availability?.total - availability?.total_on_hand - availability?.total_committed) }}
                                    </dd>
                                </div>
                                <div class="bg-gray-tier-5 rounded-lg p-8">
                                    <dt class="text-gray-475 text-sm truncate whitespace-nowrap" title="On PO">On PO</dt>
                                    <dd class="font-medium text-2xl" :class="{ 'text-orange': availability?.total_on_po < 0 }">
                                        {{ availability?.total_on_po }}
                                    </dd>
                                </div>
                                <div class="bg-gray-tier-5 rounded-lg p-8">
                                    <dt class="text-gray-475 text-sm truncate whitespace-nowrap" title="Status">Status</dt>
                                    <dd class="font-medium text-2xl">
                                        {{ product.status }}
                                    </dd>
                                </div>
                            </div>
                            <TableNew
                                :rows="inventoryRows"
                                :columns="inventoryColumns"
                                :row-component="TableRowTwo"
                                class="border-b border-keyline-primary"
                            />
                        </div>
                        <!--<div class="flex gap-4 items-center">
              <div class="group flex items-center relative">
                <button
                  :disabled="inert"
                  class="text-sm px-5 py-2 border border-black dark:border-white duration-150 hover:ring-1 ring-black dark:ring-white rounded-full"
                  @click="toggleSelectCustomerDialog($event, product)">
                  <LoadingCircle v-if="inert" class="mx-auto h-6 py-1 px-5" />
                  <span v-else class="h-6"># {{ customer.value }}</span>
                </button>
                <div v-if="!inert" class="flex items-center opacity-0 group-hover:opacity-100 duration-150 -translate-x-2 group-hover:translate-x-0">
                  <ButtonTooltip side="right" :text="customer.label" />
                </div>
              </div>
              <span v-if="inert" class="flex gap-2 w-48 h-5">
                <span class="grow bg-gray-tier-5 opacity-90 animate-pulse rounded-md" />
                <span class="w-16 bg-gray-tier-5 opacity-90 animate-pulse rounded-md" />
              </span>
              <span v-else>
                <span>{{ customer?.customer_group }} <span v-if="customer?.price_code">({{ customer?.price_code }})</span>:</span>&nbsp;
                <span class="font-semibold">{{ showMeTheMoney(pricing?.price) }}</span>
                <span class="uppercase type-tertiary font-semibold text-2xs ml-1">{{ $t('cost') }}</span>
                <span class="ml-1">({{
                  ((100 * (pricing?.price - product?.pricing_warehouse_item.std_cost)) / pricing?.price).toLocaleString('en', {
                    maximumFractionDigits: 2,
                  })
                }}%)</span>
              </span>
              <span v-if="!inert && customer && order_history">
                <button class="flex gap-0.5 font-medium type-secondary hover:type-primary" @click="historyOpen = !historyOpen">
                  <BaseSvg :name="historyOpen ? 'icon-subtraction-sign' : 'icon-addition-sign'" />
                  <span>{{ $t('Sales History') }}</span>
                </button>
              </span>
            </div>
            <Transition name="fade">
              <div v-if="historyOpen" class="mt-6">
                <div v-if="order_history?.results?.length">
                  <TableNew :row-component="TableRowTwo" :rows="order_history?.results ?? []" :columns="orderHistoryColumns" />
                </div>
                <div v-else class="bg-gray-tier-5 p-2">
                  <em class="type-primary">{{ $t('No sales history for this customer/item.') }}</em>
                </div>
              </div>
            </Transition>-->
                    </div>
                    <div v-else class="border-b border-keyline-primary pb-20">
                        <RecordsNotFound />
                    </div>
                </article>

                <!-- Performance -->
                <article
                    v-show="
                        isCurrent === 'Performance' && useUser().isEmployee()
                    "
                    class="relative app_scroll_to_header sentinel"
                    data-section="6"
                >
                    <div v-if="isLoadingMeta" class="block text-center py-24">
                        <LoadingSpinner :large="true" />
                    </div>
                    <div
                        v-else-if="performance"
                        class="border-b border-keyline-primary pb-20"
                    >
                        <div class="grid grid-cols-3 gap-4 py-8 px-6">
                            <div class="col-span-1">
                                <div class="bg-gray-tier-5 rounded-lg p-8 mb-4">
                                    <dt class="text-gray-475 text-sm">Sales YTD</dt>
                                    <dd class="font-medium text-2xl">
                                        <MoneyFormat
                                            :validate-amount="true"
                                            :truncate="true"
                                            :amount="
                                                parseInt(performance.ytd?.current?.amt)
                                            "
                                        />
                                    </dd>
                                    <dd class="text-sm type-secondary">
                                        Last Year: <MoneyFormat
                                            :validate-amount="true"
                                            :truncate="true"
                                            :amount="
                                                parseInt(performance.ytd?.previous?.amt)
                                            "
                                            strip-formatting="true"
                                            class="!inline-block"
                                        />
                                    </dd>
                                </div>
                                <div class="bg-gray-tier-5 rounded-lg p-8">
                                    <dt class="text-gray-475 text-sm">Units Sold YTD</dt>
                                    <dd class="font-medium text-2xl">
                                        {{ performance.ytd?.current?.qty }} <span class="text-sm font-normal uppercase type-tertiary">units</span>
                                    </dd>
                                    <dd class="text-sm type-secondary">
                                        Last Year: {{ performance.ytd?.previous?.qty }}
                                    </dd>
                                </div>
                            </div>
                            <div class="col-span-2">
                                <div class="bg-gray-tier-5 rounded-lg p-6">
                                    <client-only>
                                        <apex-chart
                                            height="247"
                                            type="area"
                                            :options="performanceOptions"
                                            :series="performanceSeries"
                                        />
                                    </client-only>
                                </div>
                            </div>
                        </div>

                        <TableNew
                            :row-component="TableRowProductPerformance"
                            :rows="performance.sales"
                            :columns="performanceColumns"
                        />
                    </div>
                    <div v-else class="border-b border-keyline-primary pb-20">
                        <RecordsNotFound />
                    </div>
                </article>

                <!-- Resources -->
                <article
                    v-show="isCurrent === 'Resources'"
                    class="relative sentinel"
                >
                    <div v-if="isLoadingMeta" class="block text-center py-24">
                        <LoadingSpinner :large="true" />
                    </div>
                    <div
                        v-else-if="
                            !isLoadingMeta &&
                            Object.keys(resources ?? {})?.length
                        "
                        class="py-6 at1440:p-8 pb-20 border-b border-b-keyline-primary print:hidden"
                    >
                        <div
                            v-for="(resourceGroup, groupType) in resources"
                            :key="groupType"
                            class="mb-8"
                        >
                            <h5
                                class="font-bold capitalize px-6 at1440:px-0 mb-4"
                            >
                                {{ groupType }}
                            </h5>
                            <ul>
                                <li
                                    v-for="(file, i) in groupType ===
                                    'Key Resources'
                                        ? [...resourceGroup].sort((a, b) =>
                                              (
                                                  a.tags?.[0]?.name ?? ''
                                              ).localeCompare(
                                                  b.tags?.[0]?.name ?? ''
                                              )
                                          )
                                        : [...resourceGroup].sort((a, b) =>
                                              a.name.localeCompare(b.name)
                                          )"
                                    :key="i"
                                    :title="file.name"
                                    class="border-b border-keyline-primary first-of-type:border-t"
                                >
                                    <AppFileCard
                                        :file="file"
                                        :group-type="groupType"
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-else class="block text-center py-24">
                        <div class="font-medium text-base">
                            {{ $t("We haven't listed resources here yet.") }}
                        </div>
                        <div class="type-secondary text-sm print:hidden">
                            Start a
                            <button
                                class="type-secondary underline underline-offset-4 hover:type-primary"
                                @click.stop.prevent="showNewMessage"
                            >
                                {{ $t("Live Chat") }}
                            </button>
                            to find what you need.
                        </div>
                    </div>
                </article>

                <!-- Specs -->
                <article
                    v-show="isCurrent === 'Specs'"
                    class="app_scroll_to_header relative sentinel"
                    data-section="2"
                >
                    <div
                        class="border-b at1440:border-b-0 border-keyline-primary"
                        :class="{
                            'mb-16': settings.is_sourcing_mode,
                        }"
                    >
                        <SpecsTable
                            :rows="
                                product['grouped_attributes']['product-specs']
                            "
                            :attributes="product.attributes"
                            :primary-attributes="primaryAttributes"
                            :sort-by-label="true"
                            title="Product Specs"
                        >
                            <div v-if="finishInfo?.length" class="mb-8">
                                <h5
                                    v-if="!settings.is_sourcing_mode"
                                    class="text-lg my-3 px-6 font-bold"
                                >
                                    {{ $t("Finish") }}
                                </h5>
                                <ul
                                    class="print:!text-xs"
                                    :class="{
                                        'text-sm': settings.is_sourcing_mode,
                                        'text-base at1440:grid at1440:grid-cols-3': !settings.is_sourcing_mode,
                                    }"
                                >
                                    <li v-for="row in finishInfo"
                                        :class="{
                                            'hover:bg-gray-tier-5': settings.is_sourcing_mode,
                                        }"
                                    >
                                        <Divider
                                            :class="{
                                                'block at1440:hidden': !settings.is_sourcing_mode,
                                            }"
                                        />
                                        <div
                                            class="pl-0 grid"
                                            :class="{
                                                'py-2 grid-cols-3': settings.is_sourcing_mode,
                                                'py-3 grid-cols-2 at1440:block': !settings.is_sourcing_mode,
                                            }"
                                        >
                                            <div
                                                :class="{
                                                    'px-2 col-span-1 font-medium': settings.is_sourcing_mode,
                                                    'px-6 type-primary at1440:font-medium': !settings.is_sourcing_mode,
                                                }"
                                            >
                                                {{ row.label }}
                                            </div>
                                            <div
                                                v-if="row.value"
                                                :class="{
                                                    'col-span-2': settings.is_sourcing_mode,
                                                }"
                                            >
                                                <button
                                                    @click.stop="
                                                        openArticle(
                                                            config.intercomArticles
                                                                .finishes.id
                                                        )
                                                    "
                                                    class="underline decoration-1 decoration-dotted hover:decoration-solid hover:type-primary underline-offset-4"
                                                    :class="{
                                                        'px-2 col-span-2 type-secondary break-words': settings.is_sourcing_mode,
                                                        'px-6 w-fit type-primary hover:text-red underline': !settings.is_sourcing_mode,
                                                    }"
                                                >
                                                    {{ row.value }}
                                                </button>
                                            </div>
                                            <span v-else class="px-6">—</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </SpecsTable>
                        <SpecsTable
                            v-if="
                                _.get(
                                    product,
                                    'grouped_attributes.technical-specs',
                                    false
                                )
                            "
                            :rows="
                                product['grouped_attributes']['technical-specs']
                            "
                            :attributes="product.attributes"
                            :sort-by-label="true"
                            title="Technical Specs"
                        />
                        <SpecsTable
                            v-if="
                                _.get(
                                    product,
                                    'grouped_attributes.dimensions',
                                    false
                                )
                            "
                            :rows="product['grouped_attributes']['dimensions']"
                            :attributes="product.attributes"
                            title="Dimensions"
                            class="at1440:border-b-[1px]"
                        />
                    </div>
                </article>

                <!-- Overview -->
                <article
                    v-show="isCurrent === 'Overview'"
                    v-if="product.series?.['descriptions']?.length !== 0"
                    class="relative sentinel"
                    data-section="3"
                >
                    <div
                        class="p-6 at1440:p-12 border-b border-b-keyline-primary max-w-5xl mx-auto"
                    >
                        <Overview :product="product" />
                    </div>
                </article>

                <!-- Parts -->
                <article
                    v-show="isCurrent === 'Parts'"
                    class="app_scroll_to_header relative sentinel print:hidden"
                    data-section="4"
                    v-if="product.series"
                >
                    <PartsBySeries :series="product.series" />
                </article>

                <!-- Related -->
                <article
                    v-show="isCurrent === 'Related' && companions?.length"
                    class="relative app_scroll_to_header sentinel"
                    data-section="5"
                >
                    <AppSectionHeader
                        v-model="relatedSearch"
                        title="Related"
                        :search="true"
                    />
                    <div
                        v-if="filteredCompanions.length"
                        class="border-b border-keyline-primary pb-20"
                    >
                        <TableNew
                            :rows="filteredCompanions"
                            :columns="extraColumns"
                        />
                    </div>
                    <div v-else class="border-b border-keyline-primary pb-20">
                        <RecordsNotFound />
                    </div>
                </article>

                <!-- Similar -->
                <article
                    v-show="isCurrent === 'Similar' && substitutes?.length"
                    class="relative app_scroll_to_header sentinel"
                    data-section="6"
                >
                    <AppSectionHeader
                        v-model="similarSearch"
                        title="Similar"
                        :search="true"
                    />
                    <div
                        v-if="filteredSubstitutes?.length"
                        class="border-b border-keyline-primary pb-20"
                    >
                        <TableNew
                            :rows="filteredSubstitutes"
                            :columns="extraColumns"
                        />
                    </div>
                    <div v-else class="border-b border-keyline-primary pb-20">
                        <RecordsNotFound />
                    </div>
                </article>
            </main>
        </div>
        <div
            class="fixed top-[var(--app-header-height)] bottom-0 right-0 overflow-y-auto scroll-smooth shrink-0 w-[var(--app-detail-aside-width)] z-30 print:static print:w-full"
        >
            <div
                class="flex w-full gap-2 items-center justify-end h-[calc(3rem+1px)] pr-4 bg-gray-tier-2 border-b border-keyline-primary print:hidden"
            >
                <ProductBuilder
                    v-if="builder"
                    :builder="builder"
                    :summary="summary"
                    :card="card"
                    :pricing="pricing"
                    :availability="availability"></ProductBuilder>
                <ShareButton />
                <AddToProject />
                <PinDropdownButton :id="product?.item_reference_id" type="item" />
            </div>
            <AppDetailAside
                :is-loading-meta="isLoadingMeta"
                :product="product"
                :pricing="pricing"
                :availability="availability"
                :options="options"
                :finish="finish"
                :finish_swatch="finish_swatch"
                :master_note_restriction="master_note_restriction"
                :card="card"
                :customer="customer"
                :surcharge="surcharge"
            />
        </div>
    </section>
</template>

<script setup>
import { computed, inject, markRaw, nextTick, onMounted, ref } from "vue";
import {
    eventBus,
    useAddToProjectDialog,
    useApexCharts,
    useChat,
    useShareDialog,
    useUser,
} from "@/Composables";
import {
    AppDetailAside,
    AppFileCard,
    AppNavbar,
    AppSectionHeader,
    Divider,
    HoverHint,
    LoadingSpinner,
    MoneyFormat,
    Overview,
    PartsBySeries,
    PinDropdownButton,
    ProductBuilder,
    ProductImageCarousel,
    RecordsNotFound,
    AddToProject,
    ShareButton,
    SpecsTable,
    TableNew,
    TablePrice,
    TableProductImage,
    TableRowProductPerformance,
    TableRowTwo,
    WarehouseCodeToStateFormat,
} from "@/Components";
import _ from "lodash";
import { Link, router } from "@inertiajs/vue3";
import config from "@/config";
import { DateTime } from "luxon";

const { toggleAddToProjectDialog } = useAddToProjectDialog();
const { toggleShareDialog } = useShareDialog();
const { showNewMessage, openArticle } = useChat();

const navbarSentinel = ref(null);
const isSticky = ref(false);
const { settings } = useUser();

const props = defineProps([
    "surcharge",
    "product",
    "summary",
    "errors",
    "crumbs",
    "pricing",
    "card",
    "availability",
    "options",
    "builder",
    "resources",
    "components",
    "companions",
    "substitutes",
    "isLoadingMeta",
    "referer",
    "inventory",
    "customer",
    "performance",
    "finish_swatch",
    "master_note_restriction",
    "user",
]);

const route = inject("route");

//refs
const similarSearch = ref("");
const relatedSearch = ref("");
const isCurrent = ref(null);
const initial_props = ref({});

const primaryAttributes = computed(() => [
    {
        label: "Vendor",
        value: _.get(props, "product.vendor.parent", ""),
    },
    {
        label: "Manufacturer",
        value: _.get(props, "product.vendor.display_name", ""),
    },
    {
        label: "SKU",
        value: _.get(props, "product.sku", ""),
    },
    {
        label: "UID",
        value: _.get(props, "product.uid", ""),
    },
]);

const extraColumns = [
    {
        name: "SKU",
        path: (row) => row,
        component: TableProductImage,
        props: {
            link: {
                name: "web.catalog.products.show",
            },
            preview: true,
        },
    },
    {
        name: "Manufacturer",
        path: "filter_manufacturer",
    },
    {
        name: "List",
        component: TablePrice,
        path: "list_price",
    },
];

//computed vars
const hasFinish = computed(() =>
    _.get(props, "product.typed_attributes.finish.0", false)
);

const finish = computed(() => {
    let hasFinishFamily = _.get(
        props,
        "product.typed_attributes.finish_family.0",
        null
    );
    if (hasFinish.value) {
        let finish = _.get(
            props,
            "product.attributes." + hasFinish.value,
            null
        );
        if (finish?.description) {
            return {
                image:
                    "https://d1w4srxztsilxj.cloudfront.net/media_v1_0/finishes/" +
                    finish.value.replace(/[\W_]+/u, "") +
                    ".jpg",
                value: finish.value,
                description: finish.description,
                family: _.get(
                    props,
                    "product.attributes." + hasFinishFamily,
                    null
                ),
            };
        }
    }
    return {};
});

const finishInfo = computed(() => {
    if (hasFinish.value) {
        return [
            {
                label: "Finish",
                value: finish.value?.value,
                route: {
                    name: "web.catalog.resources.index",
                },
            },
            {
                label: "Finish Description",
                value: finish.value?.description,
            },
            {
                label: "Finish Family",
                value: finish.value.family?.value,
            },
        ];
    }
    return [];
});

  const sections = computed(() => [
      {
          name: 'Resources',
          isHidden: false,
      },
      {
          name: 'Specs',
          isHidden: false,
      },
      {
          name: 'Overview',
          isHidden: _.get(props, 'product.series.descriptions', []).length === 0,
      },
      {
          name: 'Parts',
          isHidden: false,
      },
      {
          name: 'Related',
          isHidden: _.get(props, 'product.companions', []).length === 0,
      },
      {
          name: 'Similar',
          isHidden: _.get(props, 'product.substitutes', []).length === 0,
      },
      {
          name: 'Inventory',
          isHidden: !useUser().isEmployee(),
          isEmployeeOnly: true,
      },
      {
          name: 'Performance',
          isHidden: !performance && !useUser().isEmployee(),
          isEmployeeOnly: true,
      },
  ]);

  const filteredComponents = computed(() => {
  if (!partSearch.value) {
      return props.components;
  }

  return props.components.slice()
      .map((row) => _.cloneDeep(row))
      .filter((row, i) => {
          console.log(row)
          let isMatchSku = row.comp_item?.toLowerCase().includes(partSearch.value.toLowerCase());
          let isMatchDescription = row.display_short_description?.toLowerCase().includes(partSearch.value.toLowerCase());

          row.sub_components = row.sub_components?.filter((sub_component) => {
              let case1 = sub_component.comp_item?.toLowerCase()?.includes(partSearch.value?.toLowerCase());
              let case2 = sub_component.display_short_description?.toLowerCase()?.includes(partSearch.value?.toLowerCase());

              return (case1 || case2);
          });

          // If the part has been filtered out, but it contains some sub-components that match the search query.
          // Make sure to include the part with the filtered sub-components.
          return isMatchSku || isMatchDescription || row.sub_components.length
      });
});

const filteredCompanions = computed(() => {
    return _.get(props, "companions", []).filter((row) =>
        row.display_sku
            .toLowerCase()
            .includes(relatedSearch.value.toLowerCase())
    );
});

const filteredSubstitutes = computed(() => {
    return _.get(props, "substitutes", []).filter((row) =>
        row.display_sku
            .toLowerCase()
            .includes(similarSearch.value.toLowerCase())
    );
});

//events
onMounted(() => {
    eventBus.on("customer:select", (customerId) => {
        router.visit(route(route().current(), props.product.slug), {
            method: "get",
            only: ["referer", "pricing", "flash", "customer"],
            preserveScroll: true,
            data: {
                customer_id: customerId,
            },
        });
    });

    //deep clone initial props
    initial_props.value = JSON.parse(JSON.stringify(props));

    const currentHash = location.hash.slice(1);

    if (currentHash) {
        sections.value.forEach((section) => {
            if (section.name === currentHash) {
                isCurrent.value = section.name;
            }
        });
    }

    if (!isCurrent.value) {
        isCurrent.value = sections.value[0].name;
    }

    // Add intersection observer to show sticky navbar
    const observer = new IntersectionObserver(
        ([entry]) => {
            isSticky.value = !entry.isIntersecting;
        },
        {
            threshold: [0, 1],
            rootMargin: "-91px 0px 0px 0px",
        }
    );

    nextTick(() => {
        if (navbarSentinel.value) {
            observer.observe(navbarSentinel.value);
        }
    });
});

const updateSection = (section) => {
    // location.hash = "#" + section;
    isCurrent.value = section;
};

//inventory

const inventoryColumns = [
    {
        name: "WH",
        path: "warehouse",
        headClass: '!pl-8',
        cellClass: 'first-of-type:!pl-8 !font-bold tabular-nums',
    },
    {
        name: "OH",
        path: "qty_oh",
    },
    {
        name: "Cmtd",
        path: "qty_cmtd",
        cellClass: 'type-secondary',
    },
    {
        name: "BO",
        path: "qty_bo",
        cellClass: 'type-secondary',
    },
    {
        name: "PO",
        path: "qty_po",
        cellClass: 'type-secondary',
    },
    {
        name: "Min",
        path: "min_",
        cellClass: 'type-secondary',
    },
    {
        name: "Max",
        path: "max_",
        cellClass: 'type-secondary',
    },
    {
        name: "Lead",
        path: "avg_lead_time",
        cellClass: 'type-secondary',
    },
    {
        name: "Monthly",
        path: "avg_mo_usage",
        cellClass: 'type-secondary',
    },
    {
        name: "Demand",
        cellClass: 'type-secondary',
        path: (row) => {
            return Math.ceil(
                (row.avg_mo_usage / 30) * row.avg_lead_time
            ).toString();
        },
    },
    {
        name: "Safety",
        cellClass: 'type-secondary',
        path: (row) => {
            return Math.ceil(
                Math.sqrt((row.avg_mo_usage / 30) * row.avg_lead_time) * 1.65
            ).toString();
        },
    },
    {
        name: "Reorder",
        cellClass: 'type-secondary',
        path: (row) => {
            return Math.ceil(
                (row.avg_mo_usage / 30) * row.avg_lead_time +
                    Math.sqrt((row.avg_mo_usage / 30) * row.avg_lead_time) *
                        1.65
            ).toString();
        },
    },
    {
        name: "Base",
        component: markRaw(MoneyFormat),
        alignRight: true,
        props: (row) => ({
            amount: row.base_cost,
            alignRight: true,
            cellClass: 'font-normal',
        }),
    },
    {
        name: "Avg",
        component: markRaw(MoneyFormat),
        alignRight: true,
        headClass: '!pr-8',
        props: (row) => ({
            amount: row.std_cost,
            alignRight: true,
            cellClass: 'font-normal pr-6',
        }),
    },
];

const inventoryRows = computed(() => props.inventory ?? []);

const { chart_options: performanceOptions } =
    useApexCharts("chart_performance");

const performanceColumns = [
    {
        name: "WH",
        path: "sum_key_2",
        headClass: 'first-of-type:!pl-8',
        cellClass: 'first-of-type:!pl-8',
        // component: markRaw(WarehouseCodeToStateFormat),
        // props: (row) => ({
        //     code: row.sum_key_2,
        // }),
    },
    {
        name: "Month",
        path: (row) => {
            return DateTime.fromObject({
                year: parseInt(row.sum_year),
                month: parseInt(row.sum_month),
                day: 1,
            }).toFormat("LLL");
        },
    },
    {
        name: "Year",
        path: "sum_year",
    },
    {
        name: "Qty",
        path: "qty",
    },
    {
        name: "Amt",
        component: markRaw(MoneyFormat),
        alignRight: true,
        headClass: '!pr-8',
        props: (row) => ({
            amount: parseFloat(row.amt),
            alignRight: true,
            cellClass: 'font-normal !pr-6',
        }),
    },
];

function addToProject(event) {
    toggleAddToProjectDialog(event, initial_props.value);
}

const performanceSeries = computed(() => {
    return props.performance.sales.map((warehouse) => {
        return {
            // name: _.find(config.warehouses, {
            //     code: _.toString(warehouse.warehouse),
            // })?.state,
            name: warehouse.warehouse,
            data: warehouse.data
                .sort((a, b) => {
                    // Sort by year first, then by month
                    const yearDiff = parseInt(a.sum_year) - parseInt(b.sum_year);
                    if (yearDiff !== 0) return yearDiff;
                    return parseInt(a.sum_month) - parseInt(b.sum_month);
                })
                .map((month) => {
                    return {
                        x: DateTime.fromObject({
                            year: parseInt(month.sum_year),
                            month: parseInt(month.sum_month),
                            day: 1,
                        }).toFormat("LLL yyyy"),
                        y: parseFloat(month.amt),
                    };
                }),
        };
    });
});
</script>

<style>
:root {
    --app-detail-aside-width: 400px;
    interpolate-size: allow-keywords;
}

@media screen and (min-width: 1350px) {
    :root {
        --app-detail-aside-width: 550px;
    }
}

.app_scroll_to_header {
    scroll-margin-top: 136px;
}

.z-11 {
    z-index: 11;
}

.header {
    background: linear-gradient(180deg, #f4f4f4 0%, #fff 100%);
}

.dark .header {
    background: linear-gradient(180deg, #343434 0%, #2b2b2b 100%);
}

.inventory-availability {
    container-name: inventoryAvailability;
    container-type: inline-size;
}

@container inventoryAvailability (min-width: 650px) {
    .inventory-availability > * {
        @apply gap-4 text-xl;
    }

    .inventory-availability > ul {
        @apply gap-6;
    }
}
</style>
